import store from '../store/store';

export default function isLanguageSupported(language: string): boolean {
    if (store.supportedLanguageMap) {
        return store.supportedLanguageMap.has(language);
    }

    return false;
}
